export const SETTING_API_URL: string = "Setting";
export const GET_LOCATION_BY_ID_URL: string = "Location";
